import "./home.css";

export default function Home() {
  return (
    <div className="home">
      <h1>WELCOME TO ADMIN DASHBOARD</h1>
    </div>
  );
}
